import { createTheme } from '@mui/material/styles';
import { tokens } from './designTokens';

/**
 * The MUI theme, built from the design tokens in `designTokens.ts`.
 *
 * Import `tokens` from `./designTokens` rather than from here when you only need
 * a colour value — that keeps MUI out of the import graph of `constants.ts` and
 * the pure helpers in `utils/`.
 */
export { tokens };

const theme = createTheme({
  palette: {
    primary: { main: tokens.colors.primary, dark: tokens.colors.primaryHover },
    secondary: { main: tokens.colors.secondary },
    error: { main: tokens.colors.error },
    warning: { main: tokens.colors.warning },
    success: { main: tokens.colors.success },
    divider: tokens.colors.divider,
    background: {
      default: tokens.colors.background,
      paper: tokens.colors.paper,
    },
  },
  typography: {
    fontFamily: tokens.typography.fontFamily,
  },
  components: {
    // The legacy app used size="small" outlined inputs everywhere; make that the
    // default so the ported screens do not need to repeat the props.
    MuiTextField: {
      defaultProps: { size: 'small', variant: 'outlined' },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
    },
    MuiTableCell: {
      styleOverrides: {
        root: { borderColor: tokens.colors.tableBorder },
      },
    },
  },
});

export default theme;
